import React from 'react';
import { useTranslation } from 'react-i18next';
import { useStaticQuery, graphql } from 'gatsby';

import PageLayout from './PageLayout';
import SideMenu from './SideMenu';
import ArticlesPagination from './ArticlesPagination';

interface WhoWeArePageLayoutProps {
  currentSlug: string;
  withPageContentBox?: boolean;
  children: React.ReactNode;
}

const WhoWeArePageLayout = ({
  currentSlug,
  withPageContentBox,
  children,
}: WhoWeArePageLayoutProps): React.ReactElement => {
  const { t } = useTranslation();
  const data: any = useStaticQuery(
    graphql`
      {
        sanityWhoWeAre {
          teamAndContactsSection {
            departments {
              _key
            }
          }
          extraSections {
            title
            _key
            slug {
              current
            }
          }
        }
      }
    `,
  );

  const { sanityWhoWeAre: whoWeAre } = data;

  const entries = [
    {
      title: t('ascenza_page.title', 'ASCENZA'),
      url: '/who-we-are/ascenza',
      isActive: currentSlug === 'ascenza',
    },
    ...(whoWeAre.teamAndContactsSection &&
    whoWeAre.teamAndContactsSection.departments &&
    whoWeAre.teamAndContactsSection.departments.length > 0
      ? [
          {
            title: t('team_and_contacts_page.title', 'Team and Contacts'),
            url: '/who-we-are/team-and-contacts',
            isActive: currentSlug === 'team-and-contacts',
          },
        ]
      : []),
    {
      title: t('rovensa_page.title', 'ROVENSA'),
      url: '/who-we-are/rovensa',
      isActive: currentSlug === 'rovensa',
    },
    ...whoWeAre.extraSections.map((extraSection: any) => ({
      title: extraSection.title,
      url: '/who-we-are/' + extraSection.slug.current,
      isActive: currentSlug === extraSection.slug.current,
    })),
  ];

  return (
    <PageLayout
      title={t('who_we_are_page.title', 'Who we are')}
      sideBarChildren={<SideMenu entries={entries}></SideMenu>}
      withPageContentBox={withPageContentBox}
    >
      {children}
      <ArticlesPagination entries={entries}></ArticlesPagination>
    </PageLayout>
  );
};

export default WhoWeArePageLayout;
